export default class TabNavigationHelper {
    private static _instance: TabNavigationHelper;

    static get instance() {
        return this._instance || (this._instance = new this());
    }

    public setGroupAtt(el: HTMLDivElement | HTMLAnchorElement): void {
        if (el) {
            if (!el.hasAttribute('group')) {
                el.toggleAttribute('group');
            }
        }
    }

    public setFocusAtt(el: HTMLDivElement | HTMLSpanElement | Element): void {
        if(el) {
            el.setAttribute('focusable', '');
            el.setAttribute('order', '');
        }
    }

    public removeFocusAtt(el: HTMLDivElement | HTMLSpanElement | Element): void {
        if(el) {
            el.removeAttribute('focusable');
            el.removeAttribute('order');
            el.removeAttribute('tabindex');
        }
    }

    public removeGroupAtt(el: HTMLDivElement | HTMLSpanElement): void {
        if(el) {
            el.removeAttribute('group');
            el.removeAttribute('Modal');
        }
    }

    public setModalAtt(el: HTMLDivElement | HTMLAnchorElement): void {
        if(el) {
            el.setAttribute('Modal', '');
        }
    }

    public handleKeyDown(event, originElement?: string): void {
        event.stopPropagation(); // avoid triggering parent:

        // prevent page jump down on Space btn., click
        if (event.key === ' ') {//'Space'
            event.preventDefault();

            if(originElement && originElement.length > 0) {
                const element = document.querySelector(`.${originElement}`);
                setTimeout(() => {window.shell.tabNav.focus(element, 'keyboard');}, 500);
            }
        }
    }

    public focusToElement(originElement?: string, element?: Element): void {
        if(!window.shell.tabNav) // for tests
            return;

        if(originElement && originElement.length > 0) {
            const element = document.querySelector(`.${originElement}`);
            setTimeout(() => {window.shell.tabNav.focus(element, 'keyboard');}, 500);
        }

        if(element) {
            setTimeout(() => {window.shell.tabNav.focus(element, 'keyboard');}, 500);
        }
    }

    public focusFirstTileInNewPage(gridRef, focusFirstTileInNewPage, articles): void {
        if(gridRef.current && focusFirstTileInNewPage && articles.length > 0) {
            const firstOfNewPage = gridRef.current.querySelector(
                '#ats-' + articles[0].masterArticleNo) as Element;

            window.shell.tabNav.focus(firstOfNewPage, 'keyboard');
        }
    }

    public focusFirstSetInNewPage(gridRef, focusFirstTileInNewPage, sets): void {
        if (gridRef.current && focusFirstTileInNewPage && sets.length > 0) {
            const firstOfNewPage = gridRef.current.querySelector(
                '#' + sets[0].set.fsCode) as Element;

            window.shell.tabNav.focus(firstOfNewPage, 'keyboard');
        }
    }
}
